import { InvoiceDraft } from '@features/invoices/types/invoiceDraft'

export const getQuoteIdFromDraft = (salesDocumentDraft?: InvoiceDraft): string | undefined => {
  const estimateId = salesDocumentDraft?.fields.approvedEstimateId?.value

  return estimateId !== undefined ? String(estimateId) : undefined
}
